import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["open", "closed"]
  static values = {
    timezone: { type: String, default: "Australia/Sydney" },
    weekdayStart: { type: Number, default: 8 },
    weekdayEnd: { type: Number, default: 19 },
    weekendStart: { type: Number, default: -1 }, // -1 = fall back to weekday hours
    weekendEnd: { type: Number, default: -1 },
  }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 60_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: this.timezoneValue,
      hour: "numeric",
      weekday: "short",
      hour12: false,
    }).formatToParts(new Date())

    const hour = parseInt(parts.find((p) => p.type === "hour").value, 10)
    const weekday = parts.find((p) => p.type === "weekday").value
    const weekend = weekday === "Sun" || weekday === "Sat"

    const start = weekend && this.weekendStartValue >= 0 ? this.weekendStartValue : this.weekdayStartValue
    const end = weekend && this.weekendEndValue >= 0 ? this.weekendEndValue : this.weekdayEndValue
    const open = hour >= start && hour < end

    this.openTarget.classList.toggle("hidden", !open)
    this.closedTarget.classList.toggle("hidden", open)
  }
}
